"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumGuidePageSource = void 0;
/**
 * Which of the guide page\'s add-a-plan entry points started the concierge flow.
 */
exports.EnumGuidePageSource = {
    GuideIcon: 'GuideIcon',
    GuideAddPlan: 'GuideAddPlan',
    GuideHowCanIHelpYou: 'GuideHowCanIHelpYou',
    GuideNoPlans: 'GuideNoPlans',
};
//# sourceMappingURL=enum-guide-page-source.js.map